<p class="text-gray-800 dark:text-white font-semibold text-base lg:text-xl">Selected Project</p>
@if (embedData?.projects) {
  <div
    class="relative w-full py-4 px-1 flex flex-col justify-center items-center gap-4 rounded bg-gray-100"
  >
    @for (project of embedData?.projects; track $index) {
      <div
        class="relative w-full gap-2 h-12 flex flex-row justify-between items-center rounded bg-white shadow overflow-hidden"
      >
        <div
          class="relative w-[calc(100%-3.5rem)] h-full flex-none flex flex-row gap-2 items-center"
        >
          <img class="flex flex-none w-20 h-12 object-cover" [src]="project.thumbnail" alt="" />
          <p
            class="w-full text-xs lg:text-sm text-gray-800 font-semibold dark:text-white text-nowrap text-ellipsis overflow-hidden"
          >
            {{ project.title }}
          </p>
        </div>
        <button
          class="relative flex-none w-12 h-12 flex justify-center items-center"
          (click)="onClickDeteleteProject(project)"
          [ngClass]="{ 'bg-green-600': project.isSelected, 'bg-red-600': !project.isSelected }"
        >
          <div class="flex justify-center items-center text-2xl">
            <mat-icon
              [inline]="true"
              class="text-white flex justify-center items-center text-2xl"
              >{{ project.isSelected ? 'delete' : 'delete' }}</mat-icon
            >
          </div>
        </button>
      </div>
    }
  </div>
} @else {
  <div class="w-full py-12 flex flex-row justify-center items-center gap-2 rounded bg-gray-100">
    <p class="text-2xl text-gray-400 dark:text-gray-200">No Selecet Project</p>
  </div>
}
<p class="text-gray-800 dark:text-white font-semibold text-base lg:text-xl">My Projects</p>
<div
  class="relative w-full py-4 px-1 flex flex-col justify-center items-center gap-4 rounded bg-gray-100"
>
  @for (template of templates; track $index) {
    @if (!includeProject(template)) {
      <div
        class="relative w-full gap-2 h-12 flex flex-row justify-between items-center rounded bg-white shadow overflow-hidden ring-2"
        [ngClass]="{ 'ring-green-600': !template.isSelected, 'ring-red-600': template.isSelected }"
      >
        <div
          class="relative w-[calc(100%-3.5rem)] h-full flex-none flex flex-row gap-2 items-center"
        >
          <img class="flex flex-none w-20 h-12 object-cover" [src]="template.thumbnail" alt="" />
          <p
            class="w-full text-xs lg:text-sm text-gray-800 font-semibold dark:text-white text-nowrap text-ellipsis overflow-hidden"
          >
            {{ template.title }}
          </p>
        </div>
        <button
          class="relative flex-none w-12 h-12 flex justify-center items-center"
          (click)="onSelectedTemplate(template)"
          [ngClass]="{ 'bg-green-600': !template.isSelected, 'bg-red-600': template.isSelected }"
        >
          <div class="flex justify-center items-center text-2xl">
            <mat-icon
              [inline]="true"
              class="text-white flex justify-center items-center text-2xl"
              >{{ template.isSelected ? 'construction' : 'add' }}</mat-icon
            >
          </div>
        </button>
      </div>
    }
  }
</div>
